import React, { useEffect, useState } from "react";
import TopBar from "../components/TopBar";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import MobileFooter from "../components/MobileFooter";
import { useNavigate } from "react-router";
import { REACT_APP_API_PORT } from "../Api";
import axios from "axios";
import Loader from "../components/Loader";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  const navigate = useNavigate()
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const getData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(`${REACT_APP_API_PORT}user/homepage/aboutus-page-details`);
      setisLoading(false);
      if (res.data.status) {
        setData(res.data.data);
      }

    }
    catch (err) {
      setisLoading(false)
      console.log(err)
    }
  }

  const fetchMetaData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/page-seo-details/Aboutus Page`
      );
      if (res.data.status) {
        setMeta(res.data.data)
      }
    } catch (err) {
      console.error(err);
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    getData();
    fetchMetaData()
  }, []);
  return (
    <>
      <Helmet>
        <title>{meta?.meta_title}</title>
        <meta name="description" content={meta?.meta_description} />
        <meta name="keywords" content={meta?.meta_keywords} />
      </Helmet>
      <Loader isLoading={isLoading} />
      {/* <TopBar /> */}
      <Header />
      <div className="relative bg-background-back1 py-12 pt-32">
        <div className="flex flex-col items-center justify-center gap-3 sm:gap-5 lg:gap-6 xl:gap-8">
          {/* Title and Gradient Line */}
          <div className="w-full">
            <div className="flex items-center justify-center gap-1 lg:gap-4">
              <div className="w-20 lg:w-24 h-[1px] bg-gradient-to-r from-transparent via-blue-500 to-transparent relative">
                <div className="absolute inset-0 blur-[2px] bg-gradient-to-r from-transparent via-blue-500 to-transparent"></div>
                <div className="absolute inset-0 blur-[4px] bg-gradient-to-r from-transparent via-blue-400/50 to-transparent"></div>
              </div>
              <span className="w-max text-sm sm:text-base lg:text-lg xl:text-xl text-[#959efe] font-light tracking-wider">
                {data?.heading1}
              </span>
              <div className="w-20 lg:w-24 h-[1px] bg-gradient-to-r from-transparent via-blue-500 to-transparent relative">
                <div className="absolute inset-0 blur-[2px] bg-gradient-to-r from-transparent via-blue-500 to-transparent"></div>
                <div className="absolute inset-0 blur-[4px] bg-gradient-to-r from-transparent via-blue-400/50 to-transparent"></div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:w-[65%] w-full lg:px-0 px-2">
            <div className="flex justify-center">
              <h1 className="max-w-[500px] lg:px-4 px-2 z-10 whitespace-pre-wrap text-center lg:text-3xl text-xl font-bold tracking-tighter text-white dark:text-white font-sans">
                {data?.heading2}
              </h1>
            </div>


            <div className="space-y-4 my-6 mx-auto">
              <div
                className="text-sm lg:text-base xl:text-lg font-medium text-white dark:text-white"
                dangerouslySetInnerHTML={{ __html: data?.description }}
              />
              {/* <p className="text-sm lg:text-base xl:text-lg font-medium text-white dark:text-white">
                Next Future AI - World's #1 Source for All Things AI. Explore thousands of latest and trending AI Tools, AI Tutorials, AI Gadgets, AI Events, and More at one place, updated daily.
              </p>
              <p className="text-sm lg:text-base xl:text-lg font-medium text-white dark:text-white">
                Platform was launched on September 1st by Digrowfa Pvt Ltd, an IT Company In India Based in New Delhi, and reached 11.3k Visits in Sep, 20.9k Visits in Oct, and 32.7K Visits in Nov.
              </p>
              <p className="text-sm lg:text-base xl:text-lg font-medium text-white dark:text-white">
                The website is the leading platform in the world with outstanding Analytics - less bounce rate of 23.6%, high engagement with 8.82 page per visit and 17.57 minutes visit duration.
              </p>

            
              <div>
                <h2 className="lg:text-xl text-base tracking-tighter text-white dark:text-white font-bold pb-1">
                  Our mission
                </h2>
                <p className="text-sm lg:text-base xl:text-lg font-medium text-white dark:text-white">
                  Our mission is to simplify AI discovery and learning for everyone. We aim to empower AI developers, educators, students, professionals, enthusiasts, and business owners by providing a platform to explore and share AI tools, tutorials, gadgets, and events. By fostering collaboration and innovation, we strive to build a self-sustaining AI ecosystem that benefits and connects the entire AI community.
                </p>
              </div>

              
              <div>
                <h2 className="lg:text-xl text-base tracking-tighter text-white dark:text-white font-bold pb-1">
                  Our vision
                </h2>
                <p className="text-sm lg:text-base xl:text-lg font-medium text-white dark:text-white">
                  Our vision is to become the go-to platform for AI innovation, education, and collaboration. We aspire to create a world where AI is accessible to all—bridging the gap between technology and its users. By fostering a thriving community of AI developers, learners, and businesses, we aim to drive innovation, inspire learning, and shape a future where AI transforms industries and empowers individuals globally.
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default AboutUs;
